/**
 * @generated SignedSource<<32b30eb08c948836a4e32948dd3b252e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UrlMappingDestinationModeType = "STATIC" | "TEMPLATE" | "%future added value";
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
export type CreateUrlMappingInput = {
  clientMutationId?: string | null;
  name?: string | null;
  matchType: UrlMappingMatchType;
  priority?: number | null;
  sourceUrl?: string | null;
  sourceHost?: string | null;
  sourcePath?: string | null;
  regexPattern?: string | null;
  destinationUrl: string;
  destinationMode?: UrlMappingDestinationModeType | null;
  conditions?: any | null;
  active?: boolean | null;
  startsAt?: string | null;
  endsAt?: string | null;
  siteSlug: string;
};
export type UrlMappingCreateFormContainer_Mutation$variables = {
  input: CreateUrlMappingInput;
};
export type UrlMappingCreateFormContainer_MutationVariables = UrlMappingCreateFormContainer_Mutation$variables;
export type UrlMappingCreateFormContainer_Mutation$data = {
  readonly createUrlMapping: {
    readonly urlMapping: {
      readonly id: string;
    } | null;
  } | null;
};
export type UrlMappingCreateFormContainer_MutationResponse = UrlMappingCreateFormContainer_Mutation$data;
export type UrlMappingCreateFormContainer_Mutation = {
  variables: UrlMappingCreateFormContainer_MutationVariables;
  response: UrlMappingCreateFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateUrlMappingPayload",
    "kind": "LinkedField",
    "name": "createUrlMapping",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlMapping",
        "kind": "LinkedField",
        "name": "urlMapping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingCreateFormContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UrlMappingCreateFormContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9031be3f2713d78834217fe964c6196",
    "id": null,
    "metadata": {},
    "name": "UrlMappingCreateFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation UrlMappingCreateFormContainer_Mutation(\n  $input: CreateUrlMappingInput!\n) {\n  createUrlMapping(input: $input) {\n    urlMapping {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff9433f0544beb9e7dae78a42f30d44a";

export default node;
